import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectValue } from '../actions/valueSet';
import style from './continueButton.css';

class ContinueButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render() {
    const numRemaining = this.props.numToSelect - this.props.numSelected;
    return (
      <div className={style.buttonRow} >
        {this.props.isShowBack ?
          <div className={style.backButton} onClick={this.props.funcBack}>&lt;&lt; Back</div> : ''}
        { this.props.isShowBack ?
          (numRemaining > 0 ?
            <div className={style.continueButtonDisabled}>Select { numRemaining } to continue</div> :
            <div className={style.continueButtonEnabled} onClick={this.props.funcContinue}>CONTINUE</div>
          )
            :
          (numRemaining > 0 ?
            <div className={style.continueButtonFULLDisabled}>Select { numRemaining } to continue</div> :
            <div className={style.continueButtonFULLEnabled} onClick={this.props.funcContinue}>CONTINUE</div>
          )
        }
      </div>
    );
  }
}

// This is totally optional, but forces react to check the prop types
// when running in debug
ContinueButton.propTypes = {
  numSelected: PropTypes.number.isRequired,
  numToSelect: PropTypes.number.isRequired,
  isShowBack: PropTypes.func.isRequired,
  funcContinue: PropTypes.func.isRequired,
  funcBack: PropTypes.func,
};

ContinueButton.defaultProps = {
  funcBack: () => { },
};

function mapStateToProps(state, props) {
  return {};
}
function mapDispatchToProps(dispatch, props) {
  return {
    doSelect() {
      console.log('quack1');
      dispatch(selectValue(props.valueId));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContinueButton);



// WEBPACK FOOTER //
// ./src/components/continueButton.js